<template>
    <b-container fluid style="padding-left: 40px; padding-right: 40px; height: 100%;">
        <parallax :fixed="true" style="min-height: 15vh; max-height: 100vh; height: auto !important;">
            <img src="../assets/parallax_trgovci_p.jpg" alt="" style="filter: brightness(60%);">
        </parallax>

        <div>
            <h1 style="color: white;">{{ $t('common.registration') }}</h1>
            <h4 style="color: white;">{{ $t('common.registration_2') }}</h4>
        </div>

        <b-card>
            <b-card-body>
                <b-row align-h="center" >
                    <b-col style="background-color: #fff;">
                        <h3 style="padding-left: 40px;">{{ $t('common.title') }}</h3>
                    </b-col>
                </b-row>
                <b-row align-h="center" align-v="stretch" v-if="registrationInfo" style="padding-bottom: 50px;">
                    <b-col style="padding-left: 50vh; padding-right: 50vh;">
                        <h3>{{ $t('iban-input.greeting_1') }} {{registrationInfo.commonName}}</h3>
                        <br />
                        <h4 style="font-weight: normal">{{ $t('iban-input.greeting_2') }}</h4>
                        <validation-observer ref="observer" v-slot="{ invalid }">
                            <b-form @submit.prevent="onSubmit"  id="ibanForm">
                                <b-form-group :label="$t('iban-input.iban')">
                                    <validation-provider rules="required"
                                                         v-slot="{ errors }">
                                        <b-input-group>
                                            <b-form-input v-mask="mask" v-model="iban" class="border-left-0" style="height: 38px;"/>
                                        </b-input-group>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group :label="$t('iban-input.tax-number')" v-if="showTaxNumberInput">
                                    <validation-provider :rules="{ regex: /^[0-9]+$/ }"
                                                         v-slot="{ errors }">
                                        <b-input-group>
                                            <b-form-input v-mask="'########'" v-model="taxNumber" class="border-left-0"/>
                                        </b-input-group>
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-button name="submitButton" id="saveButton" value="Save" type="submit" :disabled="invalid" >{{ $t('iban-input.submit') }}</b-button>
                            </b-form>
                        </validation-observer>
                    </b-col>
                </b-row>
                <b-row align-h="center" class="text-center" v-if="loaded">
                    <b-col style="background-color: #f4f3ef; padding-left: 50vh; padding-right: 50vh;" align-self="stretch" class="align-self-stretch">
                        <h3>{{ $t('login.unknown_certificate_1') }}</h3>
                        <h4>{{ $t('login.unknown_certificate_2') }}</h4>
                        <h4>{{ $t('login.unknown_certificate_3') }}</h4>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
    import i18n from "../i18n";
    import Parallax from 'vue-parallaxy'
    import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
    import {required, regex} from 'vee-validate/dist/rules';
    import swal from "sweetalert2";
    import Vue from "vue";

    extend('required', {
        ...required,
        message: (_, values) => i18n.t('common.required', values)
    });

    extend('regex', {
        ...regex,
        message: (_, values) => i18n.t('common.regex', values)
    });

    export default {
        name: "IBANInput",
        components: { Parallax,  ValidationProvider, ValidationObserver},
        props: {
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                iban: null,
                taxNumber: null,
                showTaxNumberInput: false,
                mask: 'SI56 #### #### #### ###'
            }
        },
        computed: {
            registrationInfo() {
                return this.$store.getters.getRegistrationInfo;
            }
        },
        mounted() {
            if(this.registrationInfo.taxNumber === null || this.registrationInfo.taxNumber === 'undefined') {
                swal.fire({
                    title: this.$t('iban-input.sigen-ca'),
                    confirmButtonText: 'OK',
                    buttonsStyling: true
                })
                this.showTaxNumberInput = true;
            }
        },
        methods: {
            onSubmit(evt) {
                evt.preventDefault();
              this.showTaxNumberInput = false;
              // if(!this.taxNumber){
              //     swal.fire({
              //       title: this.$t('iban-input.verify-tax-number-fail'),
              //       confirmButtonText: 'OK',
              //       buttonsStyling: true
              //     })
              //     return;
              //   }
                let query = {
                    taxNumber: this.taxNumber
                };

                this.$store.dispatch('verifyTaxNumbers', query)
                    .then((response) => {
                        if (response.code === 0) {
                            let query = {
                                'iban': this.iban,
                                'taxId': this.taxNumber
                            };

                            this.$store.dispatch('checkIban', query)
                                .then(() => {
                                    this.$router.push('/home/registration');
                                })
                                .catch(error => {
                                    this.$store.commit('setError', error);
                                    // TODO FIXME XXX handle different IBAN CHECK error codes!

                                })
                                .finally(()=>{
                                });
                        } else if (response.code === 564) {
                            this.showTaxNumberInput = true;

                            swal.fire({
                                title: this.$t('iban-input.sigen-ca'),
                                confirmButtonText: 'OK',
                                buttonsStyling: true
                            })
                            // swal -> sigenca - vpiš tax nr
                        } else {
                            this.showTaxNumberInput = true;
                            swal.fire({
                                title: this.$t('iban-input.verify-tax-number-fail'),
                                confirmButtonText: 'OK',
                                buttonsStyling: true
                            })
                        }

                    })
                    .catch(error => {
                        this.$store.commit('setError', error);
                        // TODO FIXME XXX handle different VERIFY TAX NUMBER error codes!
                        this.showTaxNumberInput = true;
                    })
                    .finally(() => {
                    });

                // call check iban and redirect to registration form
                // map the response error to different error messages
                /*
                case 0:
                    	// state = "IBANvalid" : IBAN was found in AJPES registry
                    	console.log("IBAN '" + iban + "' is valid.");
                        $scope.state = "IBANvalid";
                        break;
                    case 403:
                    	console.log("BWA for IBAN '" + iban + "' already exists.");
                    	$scope.state = "BWAalreadyExistsError";
                        $scope.error = response.message;
                        return false;
                    case 404:
                    	console.log("No account for IBAN '" + iban + "' found.");
                    	$scope.state = "IBANnotFoundError";
                        $scope.error = response.message;
                        return false;
                    case 405:
                    	console.log("Account found for IBAN '" + iban + "' is not active.");
                    	$scope.state = "IBANnotActiveError";
                        $scope.error = response.message;
                        return false;
                    case 406:
                    	console.log("No data on tax id for IBAN '" + iban + "'.");
                    	$scope.state = "IBANnoTaxIdError";
                        $scope.error = response.message;
                        return false;

                    default:
                        console.log("Error checking IBAN");
                    	$scope.state = "checkIBANError";
                        $scope.displayError(response.code, response.message);
                        return false;

            },
            imputChanged() {


                /*
                    if ($scope.user.ibanNoPrefix.startsWith("SI56"))
                        $scope.user.ibanNoPrefix = $scope.user.ibanNoPrefix.substring(4);

                    $scope.user.iban = $filter('iban')("SI56" + $scope.user.ibanNoPrefix.replace(/\s+/g, ''));
                    $scope.user.ibanNoPrefix = $scope.user.iban.substring(5);
                 */
            }
        }
    }
</script>

<style scoped>
#saveButton:disabled {
  color:black;
}

</style>